// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IBookCoworkingRequest,
  TBookCoworkingModel,
  IMappers,
  TBookCoworkingResponse,
  IBookCoworkingResponse,
  IBookCoworkingResponseError,
} from './types';

export const defaultConfig: TBookCoworkingModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'coworking',
  pathApi: '/v1/book-coworking/',
  requestType: 'json',
} as TBookCoworkingModel;

export function createBookCoworkingModel(parameters: IBookCoworkingRequest): TBookCoworkingModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IBookCoworkingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IBookCoworkingRequest;
}

export async function fetchBookCoworking<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IBookCoworkingOptions<TResponse200, TResponse400>): Promise<TBookCoworkingResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createBookCoworkingModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IBookCoworkingResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IBookCoworkingResponseError);
    }

  }
  return {
    statusCode,
    response,
    headers,
  } as TBookCoworkingResponse;
}
